import classNames from "classnames";
import { split } from "lib/util";
import byndBadge from "public/by-nd.png";
import bysaBadge from "public/by-sa.png";
import byBadge from "public/by.png";
import cczeroBadge from "public/cc-zero.png";
import infoIcon from "public/icons/info.svg";
import { useState } from "react";
import { Icon } from "./Icon";

const LicenseIcon = ({ license }: { license: string }) => {
  const badge =
    license === "CC BY-ND"
      ? byndBadge
      : license === "CC BY-SA"
      ? bysaBadge
      : license === "CC BY"
      ? byBadge
      : license === "CC0"
      ? cczeroBadge
      : null;
  return badge ? (
    <img src={badge} alt={`Lizenz ${license}`} style={{ width: "70px" }} />
  ) : (
    <>Lizenz: {license}</>
  );
};

export const ImageAttribution = ({
  images,
}: {
  images: Array<Travelguide.Image>;
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const ids = images.map(({ id }) => id);
  const ownSourceName = "Tourist-Information Salzgitter";
  const [ownImages, otherImages] = split(
    images,
    ({ author, source, license }) =>
      [author, source].join("") !== ownSourceName || Boolean(license)
  );
  return (
    <div className="flex flex-col gap-5 px-4 md:px-6">
      <div
        className="flex flex-row gap-x-2 cursor-pointer"
        onClick={() => setIsOpen(!isOpen)}
      >
        <Icon src={infoIcon} size={20} />
        Bildquellen
      </div>
      <small>
        <div
          className={classNames(
            "flex flex-col gap-y-4 h-fit",
            "overflow-y-auto transition-all duration-200 ease-in-out",
            {
              "max-h-96": isOpen,
              "max-h-0": !isOpen,
            }
          )}
        >
          {ownImages.length > 0 && (
            <>
              {ownImages.length === 1
                ? "Bild"
                : `Bilder ${ownImages
                    .map(({ id }) => ids.indexOf(id) + 1)
                    .join(", ")}`}
              : {ownSourceName}
            </>
          )}
          {otherImages.map(({ id, title, author, source, license }, i) => (
            <div key={i}>
              Bild {ids.indexOf(id) + 1}
              {title && <>: {title && <>&quot;{title}&quot;</>}</>}
              <br />
              {author && <>{author}, </>}
              {source}
              {license && (
                <div className="mt-2">
                  <LicenseIcon license={license} />
                </div>
              )}
            </div>
          ))}
        </div>
      </small>
    </div>
  );
};
